import { useState } from "react";
import { Link } from "react-router-dom";
import { FiEye, FiEyeOff } from "react-icons/fi"; // 👈 import icons
import ThemeToggle from "../../../components/ThemeToggle";
import logo from "../../../assets/logo.svg";

export default function SignUp({ theme, setTheme }) {
  const [formData, setFormData] = useState({
    email: "",
    phone: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false); // 👈 state for toggle

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Data:", formData);
  };

  return (
    <div className="flex min-h-screen">
      {/* Left side - Sign up form */}
      <div className="w-full md:w-1/2 flex flex-col justify-center px-8 lg:px-20 bg-white dark:bg-gray-900 transition-colors duration-300 relative">
        {/* Mobile Theme Toggle */}
        <div className="absolute top-4 right-4 md:hidden">
          <ThemeToggle theme={theme} setTheme={setTheme} />
        </div>

        <div className="max-w-md w-full mx-auto space-y-6">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">
            Sign Up Now
          </h1>
          <p className="text-gray-600 dark:text-gray-400 mb-6">
            Enter the following details to create a new account. Get started now
          </p>

          {/* Form */}
          <form onSubmit={handleSubmit} className="space-y-8">
            {/* Email */}
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Email
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="your@email.com"
                className="w-full px-4 py-3 border rounded-md focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 dark:bg-gray-800 dark:border-gray-700 dark:text-white"
                required
              />
            </div>

            {/* Phone Number */}
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Phone Number
              </label>
              <input
                type="text"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="1234567"
                className="w-full px-4 py-3 border rounded-md focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 dark:bg-gray-800 dark:border-gray-700 dark:text-white"
                required
              />
            </div>

            {/* Password with eye toggle */}
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Password
              </label>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Min. 8 characters"
                  className="w-full px-4 py-3 border rounded-md focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 dark:bg-gray-800 dark:border-gray-700 dark:text-white pr-10"
                  required
                />
                {/* Eye icon */}
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute inset-y-0 right-3 flex items-center text-gray-500 dark:text-gray-300"
                >
                  {showPassword ? <FiEyeOff size={20} /> : <FiEye size={20} />}
                </button>
              </div>
            </div>

            {/* Submit button */}
            <button
              type="submit"
              className="w-full py-2 bg-indigo-900 text-white font-medium rounded-md shadow hover:bg-indigo-800 transition"
            >
              Create A New Account
            </button>
          </form>
        </div>
      </div>

      {/* Right side - Branding */}
      <div className="hidden md:flex w-1/2 bg-indigo-900 text-white flex-col items-center justify-center relative">
        <div className="flex flex-col items-center">
          <div className="w-24 h-24 flex items-center justify-center mb-6">
            <img src={logo} alt="Logo" />
          </div>
          <h2 className="text-7xl font-bold">Secure Chat AI</h2>
        </div>

        {/* Desktop Theme Toggle */}
        <div className="absolute top-4 md:top-20 right-4 md:right-20">
          <ThemeToggle theme={theme} setTheme={setTheme} />
        </div>
      </div>
    </div>
  );
}
